import { useLocalSearchParams } from 'expo-router';

import { CityEventsScreen } from '@/components/riviera/city-events-screen';

export { generateCityEventsStaticParams as generateStaticParams } from '@/lib/detail/city-listings-detail';

// One city's upcoming events, e.g. /en/nice/events — the landing page for
// "events in nice" searches. Nested under the city guide (/en/nice) rather
// than /en/events/nice, because events/[id] already owns that dynamic segment.
// Only cities with enough events are exported — see city-listings-detail.ts.
export default function CityEventsRoute() {
  const { city } = useLocalSearchParams<{ city: string }>();
  return <CityEventsScreen cityId={city ?? ''} />;
}
